import React from 'react';
import ErrorMessage from "../../components/ErrorMessage";
import HomeScreen from "../homescreen/homescreen";
import LoadingComponent from "../../components/Loading";
import Service from "../../service/service";

class Tools extends HomeScreen {

    state = {
        loading: true,
        error: null,
        serviceStatus:   []
    };

    service = new Service();

    renderHomeContent() {

        const {loading, error, serviceStatus} = this.state;

        return (
            <div>
                <LoadingComponent isLoading={loading} />

                <ErrorMessage errorMessage={error} />

                {!error && !loading &&
                    serviceStatus.map(service => <p key={service}>{service.serviceName}: {service.status}</p>)}
            </div>
        );
    }

    componentDidMount() {
        //axios.get('/analytics/serviceStatus')
        this.service.getServiceStatus()
            .then(r => {
                this.setState({serviceStatus: r.data, loading: false});
            })
            .catch(error =>{
                console.log(error);
                this.setState({
                    loading: false,
                    error: 'There was an error loading the section..'
                })
            });
    }

    getScreenName() {
        return 'Tools';
    }
}

export default Tools;


// WEBPACK FOOTER //
// ./src/screens/tools/index.js